export default "__VITE_ASSET__c9b9869c__"